<template>
     <modal class="shangLvDiscountModel" :isShow="isShow" @keyup.esc="hide" >
        <div class="header">商旅会员折扣权益核销<span class="close" @click="hide()">×</span></div>
        <div class="The-head">
            请扫码或输入权益码:
            <div class="from-input">
                <input type="text" ref="input" class="key-focus" data-model='idCode' v-model="idCode" @keyup.enter="onMemberInfo()" />
            </div>
            <button class="btn" @click="onMemberInfo()">查询</button>
        </div>
        <div class="modal-body">
            <div class="info-box">
                <div class="title">折扣权益说明：</div>
                <div class="tr-li"> 
                    <span class="name">折扣率：</span>
                    <span class="lable-text">{{meberInfo?.CardKind_DiscountRate}}</span>
                </div>
                <div class="tr-li"> 
                    <span class="name">备注：</span>
                    <span class="lable-text">{{meberInfo?.Remark}}</span> 
                </div>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn btn-cancel" @click="hide()">取消</button>
            <button class="btn btn-confirm" @click="confirm()" v-throttle>确定折扣</button>
        </div>
    </modal>
</template>

<script>
export default {
    emits:["close","discountConfirm"],
    props:{
        isShow:{
            type:Boolean
        },
        /**所点菜品 */
        orderMenuList:{
            type:Object
        },
    },
    data(){
        return {
            //卡号
            idCode:"",
            //会员信息
            meberInfo:null,
        }
    },
    mounted(){
        setTimeout(() => {
            if(this.$refs.input){
                this.$refs.input.focus();
            }
        },100);
    },
    methods:{
        hide(){
            this.$emit("close");
        },
        /**读卡 */
        onMemberInfo(){
            this.idCode =this.idCode.replace(/[;,；,=,＝,?,？]/g,"");
            if(!this.idCode){
                this.$message.warning('查询码不能为空');
                return
            }
            this.userInfo=this.$auth.getUserInfo(); //获取用户id
            let param={
                User_ID:this.userInfo?.User_ID,  //用户id
                DynamicNo:this.idCode,
                Card_AutoID:'',
                Card_SN:'',
                Member_Type:35,//35：商旅会员
            };
            const loading = this.$loading({
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.1)",
            });
            console.log(param)
            this.$httpAES.post("Bestech.CloudPos.GetMemberInfo",param).then((data)=>{
                loading.close();
                console.log(data);
                if(data.ResponseHeader.ResultCode!=0){
                    this.$message.error(data.ResponseHeader.ResultDesc);
                    this.idCode=''
                }else{
                    if(data.ResponseBody?.length>0){
                        this.meberInfo=data.ResponseBody[0];
                    }
                }
            }).catch((e)=>{
                loading.close();
                this.$alert(e.message, "提示", {confirmButtonText: "确定"});
            })
        },
        /**确定折扣 */
        confirm(){
            if(!this.meberInfo){
                this.$message.warning("请先读取会员信息！");
                return;
            }
            if(this.meberInfo.Open_CardKind_Discount==0 || this.meberInfo.CardKind_DiscountRate==0){//是否开启卡类全单折扣 0：否， 1：是
                this.$message.warning("本订单客户没有优惠！");
                return;
            }
            let _orderConsumes=[];
            this.orderMenuList?.forEach((item)=>{               
                if(item.Food_Status==-1 && !item.is_taste){
                    let SizeNumber = Number(item?.AssSizeNumber)
                    let Food_Types =1;
                    let _seep= item.Food_Speed
                    if(item.Food_Speed=='' || item.Food_Speed==null){
                        _seep='即'
                    }
                    if(item.FoodSetmeals!=null){
                        Food_Types=2
                        SizeNumber=0
                    }
                    if(item.DiyTcType){
                        Food_Types=item.DiyTcType
                    }
                    let orders ={
                        Food_ID:item.EAT_XFBMID,
                        Food_Code:item.EAT_XFCode,
                        Food_Type:Food_Types,
                        Food_Speed:_seep,
                        Food_Size:item.Eat_XFSize,
                        Food_Number:item.Eat_Number,
                        Food_Price:item.Eat_SalePrice,
                        Food_CheckPrice:item.Eat_CheckPrice,
                        FoodModifys:item.FoodModifys,
                        FoodSetmeals:item.FoodSetmeals,
                        Food_Name:item?.EAT_XFName,
                        Food_AssNumber:SizeNumber,
                        Eat_ConsumeID:item.Eat_ConsumeID
                    };
                    _orderConsumes.push(orders);
                } 
            })
            if(_orderConsumes.length==0){
                this.$message.warning("没有可折扣的菜品,请先去点菜");
                return;
            }
            let param={
                User_ID:this.userInfo?.User_ID,
                Operator_Name:this.userInfo?.Login_Name,
                Member_sys:35,//35：商旅会员
                Kind:3,//1：折扣方案，5：金额折扣 ，3：全单折扣，4：单品折扣
                DiscountScheme_AutoID:"",
                DiscountScheme_ZkRate:this.meberInfo.CardKind_DiscountRate,
                ThirdOrgExtendInfo:this.meberInfo.ThirdOrgExtendInfo,
                OrderConsumes:_orderConsumes,
            }
            const loading = this.$loading({
                text: "折扣提交中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CloudPos.DealWithTheSnackDiscount",param).then((data)=>{
                console.log(data)
                loading.close();
                if(data.ResponseHeader.ResultCode!=0){
                    this.$message.error(data.ResponseHeader.ResultDesc);
                }else{
                    this.$message.success({ message: "折扣计算完成"});
                    
                    this.$emit("discountConfirm",data);
                    this.hide();
                }
            }).catch((e)=>{
                loading.close();
                this.$alert(e.message, "提示", {confirmButtonText: "确定"});
            })
        }
    }
}
</script>

<style lang="sass">
@import "./shangLvDiscountModel.scss";
</style>